var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAvalancheTestnet24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#222",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m145.495 77.084a.665.665 0 0 1 1.259 0l2.17 3.809c.348.6.063 1.093-.633 1.093h-4.371c-.689 0-.974-.491-.634-1.093zm-4.2-7.333a.659.659 0 0 1 1.251 0l.483.871 1.14 2a2.081 2.081 0 0 1 0 1.813l-3.825 6.628a2.011 2.011 0 0 1 -1.568.919h-3.176c-.7 0-.982-.483-.633-1.093z",
    fill: "#fff",
    transform: "translate(-129.947 -65.051)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvalancheTestnet24);
export default __webpack_public_path__ + "static/media/ic_avalanche_testnet_24.b911b6d28a3d713a95ebdacf442ad6ca.svg";
export { ForwardRef as ReactComponent };